import { render, staticRenderFns } from "./IgnoreButton.vue?vue&type=template&id=d7a31170&"
import script from "./IgnoreButton.vue?vue&type=script&lang=js&"
export * from "./IgnoreButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports